// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__3t_9R"};